<template lang="pug">
  .container(id="StatusBarMedia-container")
    .item.selected-media-counter(id="StatusBarMedia-selectedMediaCounter" @click='showSelectedMedia()', :title='$t("Selected media")', :class="{ 'active': mediaSelectedCounter > 0 }")
      font-awesome-icon(icon="check-square")
      span &nbsp; {{ mediaSelectedCounter }}
    .item.separator
    .item.current-upload-counter(id="StatusBarMedia-currentUploadCounter" @click='showFilesInConvertion()', :title='$t("Files uploading")', :class="{ 'active': filesUploadingCounter > 0 }")
      font-awesome-icon(icon="upload")
      span &nbsp; {{ filesUploadingCounter }}
    .item.current-upload-counter(id="StatusBarMedia-currentConversionCounter" @click='showFilesInConvertion()', :title='$t("Media in conversion")', :class="{ 'active': filesInConversionCounter > 0 }")
      font-awesome-icon(icon="file-video")
      span &nbsp; {{ filesInConversionCounter }}
    //- .item.separator
    //- .item.current-upload-counter(@click='showCopiedTags()', :title='$t("Copied tags")', :class="{ 'active': tagsCopiedCounter > 0 }")
    //-   font-awesome-icon(icon="tags")
    //-   span &nbsp; {{ tagsCopiedCounter }}
    el-dialog(:visible.sync="showSelectedMediaVisible", @close='showSelectedMediaVisible = false', :close-on-click-modal="false")
      ShowSelectedMedia
    el-dialog(:visible.sync="showFilesInConvertionVisible", @close='showFilesInConvertionVisible = false', :close-on-click-modal="false")
      FileList
</template>

<script>
import ShowSelectedMedia from './Medium/ShowSelectedMedia'
import FileList from './File/List'

export default {
  props: [],
  components: {
    ShowSelectedMedia,
    FileList
  },
  created () {
    this.$store.dispatch('Medium/activateWsListener')
    this.$store.dispatch('File/activateWsListener')
  },
  data () {
    return {
      showSelectedMediaVisible: false,
      showFilesInConvertionVisible: false
    }
  },
  methods: {
    showSelectedMedia () {
      this.showSelectedMediaVisible = true
    },
    showFilesInConvertion () {
      if (this.filesInConversionCounter > 0) {
        this.showFilesInConvertionVisible = true
      }
    }
  },
  computed: {
    tagsCopiedCounter () {
      return this.$store.state.Clipboard.copied_media_tags.length
    },
    filesInConversionCounter () {
      return this.$store.state.File.file_list.filter(file => file.convertionProgress !== 100).length //  + '/' + this.$store.state.File.file_list.length
    },
    filesUploadingCounter () {
      return this.$store.state.File.files_uploading.filter(fileUploading => fileUploading.status !== 'success').length
    },
    mediaSelectedCounter () {
      return this.$store.state.Medium.media_selected_left.length
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../theme-m4b/src/common/var.scss";
.container {
  display: flex;
  padding: 5px 20px;
  justify-content: space-between;
  align-items: stretch;
  .item {
    padding: 0px 8px;
    cursor: pointer;
    opacity: 0.3;
    &.active {
      opacity: 1;
    }
    &.separator {
      border-right: $--border-light;
      margin-right: 20px;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatusBarMedia.vue